export default "__VITE_ASSET__b7fb2c87__"